import { Component, Inject, OnInit, Input } from "@angular/core";
import { WINDOW } from "../../../providers/window-providers.service";

@Component({
  selector: 'app-project',
  templateUrl: 'project.component.html',
  styleUrls: ['project.component.scss']
})
export class ProjectComponent implements OnInit {

  @Input() projects:any;

  constructor(@Inject(WINDOW) private window) { }

  ngOnInit() {
  }

  openAppStore(p:any) {
    this.window.open(p["ioslink"]);
  }

  openWindowStore(p:any) {
    this.window.open(p["windowslink"]);
  }

  openPlayStore(p:any) {
    this.window.open(p["androidlink"]);
  }
}




// WEBPACK FOOTER //
// ./src/components/organization/project/project.component.ts